<button
  (click)="toggleFilter()"
  mat-stroked-button
  class="filter-button fz-button--small"
  color="primary"
  data-ga-value="filter-button"
>
  <mat-icon [ngClass]="{ selected: isSelected && !showFilter }">{{
    !showFilter ? 'filter_list' : 'close'
  }}</mat-icon>
  <img
    width="18"
    height="18"
    class="filter-button__img"
    *ngIf="isSelected && !showFilter"
    src="/shared/svg/filter-selected-{{ colorScheme || 'light' }}.svg"
  />
  <span class="filter-button__label">{{
    !showFilter ? 'Filters' : 'Close'
  }}</span>
</button>
